import React from 'react';

import PlainLink from '../../../components/util/PlainLink/PlainLink';
import Typography from '@mui/material/Typography';
import HomeFeatureButton from '../../../components/util/HomeFeatureButton/HomeFeatureButton';
import { faAdd } from '@fortawesome/free-solid-svg-icons/faAdd';
import { faHistory } from '@fortawesome/free-solid-svg-icons/faHistory';

function UserHome(props) {
  return (
    <>
      <PlainLink to="/user">
        <Typography variant="pageTitle">User Dashboard</Typography>
      </PlainLink>
      <HomeFeatureButton
        to={'/user/application/create'}
        text="Apply Card Replacement"
        icon={faAdd}
      />
      <HomeFeatureButton
        to={'/user/application/list'}
        text="Application History"
        icon={faHistory}
      />
      {/* <div style={{fontSize: 14, marginTop: 40}}>
        Notes:
        <ol>
          <li>
            Card replacement system is not applicable to PolyU award programmes administered by SPEED and Research programmes with intake cohorts before 2018/19 academic year.
          </li>
        </ol>
      </div> */}
    </>
  );
}

export default UserHome;